import buildService from 'common/utils/build-service'
import { GET } from 'common/requests'

interface AudienceTypesUrlParams {
  audienceId?: string
}

export default buildService<AudienceTypesUrlParams, unknown, unknown, unknown>({
  type: GET,
  constantsPrefix: 'AUDIENCE_TYPES',
  isArray: true,
  http: {
    createApiUrlSuffix: ({ audienceId }) => {
      if (audienceId) {
        return `/audience_types?id=eq.${audienceId}`
      }
      return `/audience_types`
    },
  },
})
